import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: 'ad2c35de-493e-4840-bb87-82265f3b5ca9',
  header: '	eGP pre-visit consultation',
  headerLogoUrl: {
    light: '/logos/egp.svg',
    dark: '/logos/egp.svg',
  },
  subheader: '',
  version: 'Prototüüp',
  logo: 'egp.svg',
  theme: {
    isLight: true,
    bgColor: 'bg-[#115E67]',
    textColor: 'text-[#115E67]',
    bubbles: 'bg-[#64CCC9]',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/egp',

  tabsInSidebar: false,
}

export default config
